import { Icon } from '@iconify/react';
import React from 'react';
import Slider from 'react-slick';
import Div from '../Div';
import TestimonialStyle2 from '../Testimonial/TestimonialStyle2';


const testimonialData = [
  {
    avatarImgUrl: '/images/DP1.jpg',
    testimonialText:
      'Vox Motion made the whole process super easy! Jaleel just got what we were looking for and turned it into something clean and professional. Really happy with how it all turned out.',
    avatarName: 'Sandor Barany',
    avatarDesignation: 'CEO - AI GALAXY',
    ratings: '5',
  },
  {
    avatarImgUrl: '/images/DP2.jpg',
    testimonialText:
      'Jaleel is an absolute pleasure to work with. Whatever project we have worked together on, he has not only brought his incredible editing virtuosity but also his vibrant creative energy. Highly recommended!',
    avatarName: 'Hannah Martin',
    avatarDesignation: 'AWARD WINNING ATHLETE & PROFESSIONAL DANCER | CEO, MAKE IT HAPPEN ACADEMY',
    ratings: '5',

  
  },
  {
    avatarImgUrl: '/images/DP3.jpg',
    testimonialText:
      'I am really impressed with the quality Vox Motion has delivered and the professionalism of the team. Despite the complexity of the project and multiple teams working at once, they pulled it off seamlessly. Highly Recommended!',
    avatarName: 'Alex Aiono',
    avatarDesignation: 'MUSICIAN',
    ratings: '5',
  },
  {
    avatarImgUrl: '/images/DP4.jpg',
    testimonialText:
      'These guys totally nailed the edit. They took my rough ideas and turned them into something that just worked right on vibe. Super easy to work with too. Would happily team up again! Bravo!',
    avatarName: 'Zach King',
    avatarDesignation: 'CONTENT CREATOR',
    ratings: '5',
  },
  {
    avatarImgUrl: '/images/DP5.jpg',
    testimonialText:
      'I worked with Jaleel and he was awesome in editing videos for a course that I was doing! He took my very plain footage and turned into somethin very very magical! ',
    avatarName: 'Nicole Sabella',
    avatarDesignation: 'NUTRITIONIST | FOUNDER, THE NOURISHED DANCER',
    ratings: '5',
  },
  ];

export default function TestimonialSliderStyle4() {
  /** Team Member Data **/

  /** Slider Settings **/
  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    <div
      {...props}
      className={
        'slick-prev slick-arrow' + (currentSlide === 0 ? ' slick-disabled' : '')
      }
      aria-hidden="true"
      aria-disabled={currentSlide === 0 ? true : false}
    >
      <Icon icon="bi:arrow-left" />
    </div>
  );
  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <div
      {...props}
      className={
        'slick-next slick-arrow' +
        (currentSlide === slideCount - 1 ? ' slick-disabled' : '')
      }
      aria-hidden="true"
      aria-disabled={currentSlide === slideCount - 1 ? true : false}
    >
      <Icon icon="bi:arrow-right" />
    </div>
  );
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <Slider {...settings} className="cs-gap-24 cs-arrow_style2">
      {testimonialData.map((item, index) => (
        <Div key={index}>
          <TestimonialStyle2 {...item} />
        </Div>
      ))}
    </Slider>
  );
}
